import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useUsersContext } from "../../context/usersContext";
import TaskCard from "../Chat/components/WelcomeSections/TaskCard";
import TasksFilterBar from "../Chat/components/WelcomeSections/TasksFilterBar";
import useTaskCardActions from "../Chat/hooks/useTaskCardActions";
import useRunTask from "./hooks/useRunTask";


  // const getLocalScheduleTime = (task) => {
  //   if (!task?.scheduleTime) return "";
  //   if (task?.utcTime) {
  //     return moment.utc(task.utcTime, "HH:mm").tz(timeZone).format("HH:mm");
  //   }
  //   if (task?.time_zone) {
  //     return moment
  //       .tz(task.scheduleTime, "HH:mm", task.time_zone)
  //       .tz(timeZone)
  //       .format("HH:mm");
  //   }
  //   return task.scheduleTime;
  // };

const formatOutputLabel = (value) => {
  if (!value) return "Unknown";
  // if (value.toLowerCase() === "chatui") return "Chats";
  return value
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const Tasks = () => {
  const { tasksData, fetchTasksData } = useUsersContext();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTools, setSelectedTools] = useState([]);

  const fetchTasks = useCallback(async () => {
    await fetchTasksData();
  }, []);

  const { bindActions, actionModals } = useTaskCardActions({
    onTasksChanged: fetchTasks,
  });
  const { runTask } = useRunTask();

  const toggleTool = useCallback((tool) => {
    setSelectedTools((prev) =>
      prev.includes(tool) ? prev.filter((t) => t !== tool) : [...prev, tool]
    );
  }, []);

  const clearTools = useCallback(() => setSelectedTools([]), []);

  const toolOptions = useMemo(() => {
    const list = tasksData?.prompt || [];
    const seen = new Map();
    list.forEach((item) => {
      const value = item?.output;
      if (!value || seen.has(value)) return;
      if (value.toLowerCase() === "chatui") return;
      seen.set(value, { value, label: formatOutputLabel(value) });
    });
    return Array.from(seen.values()).sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  }, [tasksData]);

  const filteredTasks = useMemo(() => {
    const list = tasksData?.prompt || [];
    const term = searchTerm.trim().toLowerCase();
    const normalizedSelected = selectedTools.map((s) =>
      String(s || "").trim().toLowerCase()
    );
    return list.filter((item) => {
      if (normalizedSelected.length > 0) {
        const itemOutput = String(item?.output || "").trim().toLowerCase();
        if (!normalizedSelected.includes(itemOutput)) return false;
      }
      if (!term) return true;
      return (
        (item?.title || "").toLowerCase().includes(term) ||
        (item?.prompt_value || "").toLowerCase().includes(term)
      );
    });
  }, [tasksData, searchTerm, selectedTools]);

  const handleTaskCardClick = (task) => runTask(task);

  useEffect(() => {
    fetchTasks();
  }, []);

  return (
    <div className="w-full h-full flex justify-center overflow-hidden">
      <div className="newUI_container v3chat__input !h-full overflow-y-auto">
        <div className=" justify-between items-center mb-7">
          <div className="text-2xl font-semibold tracking-tight">All Tasks</div>
          <p className="text-[#64748b]">Browse, configure, and schedule tasks to add to your workflow. They can be triggered automatically and delivered into Slack, MS Teams or to your product.</p>


        </div>

        {tasksData?.prompt?.length > 0 && (
          <div className="mt-4 mb-2">
            <TasksFilterBar
              search={searchTerm}
              onSearchChange={setSearchTerm}
              selectedTools={selectedTools}
              onToggleTool={toggleTool}
              onClearTools={clearTools}
              toolOptions={toolOptions}
            />
          </div>
        )}

        <div className="grid grid-cols-2 gap-4">
          {filteredTasks.map((task) => {
            const repeatLabel =
              task.repeat && task.repeat !== "none"
                ? `Repeats ${task.repeat}`
                : "Run anytime";
            const isChatUi =
              !task.output || task.output.toLowerCase() === "chatui";
            const tools = isChatUi ? [] : [task.output];
            return (
              <TaskCard
                key={task._id || task.id}
                title={task.title}
                description={task.prompt_value}
                metaLabel={repeatLabel}
                tools={tools}
                buttonLabel="Run this task"
                onClick={() => handleTaskCardClick(task)}
                {...bindActions(task)}
              />
            );
          })}
        </div>

        {tasksData?.prompt?.length > 0 && filteredTasks.length === 0 && (
          <div className="text-center text-[13px] text-[#64748b] py-12">
            No tasks match your filters.
            {selectedTools.length > 0 && (
              <button
                type="button"
                onClick={clearTools}
                className="ml-2 underline hover:text-black"
              >
                Clear filters
              </button>
            )}
          </div>
        )}

        {actionModals}
      </div>
    </div>
  );
};

export default Tasks;
